import { render, staticRenderFns } from "./CompanyAmalgamation.vue?vue&type=template&id=a1ea6d94&scoped=true&"
import script from "./CompanyAmalgamation.vue?vue&type=script&lang=js&"
export * from "./CompanyAmalgamation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAmalgamation.vue?vue&type=style&index=0&id=a1ea6d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ea6d94",
  null
  
)

export default component.exports